import { useQuery } from '@tanstack/react-query';
import { repositoryFactory, DataSourceStrategy, CacheStrategy, } from '@rammetec/data-access';
import { USER_ORGS } from '@vectorhub/domain';
/**
 * Fetches the org IDs for a user from Firestore (user/{userId}/orgs).
 *
 * This matches how SysColect resolves org membership in the shared Firebase project
 * (syscolect-ramme-2). The initial Phase-4 approach of reading a custom claim
 * (user.orgIds) was wrong — SC uses Firestore, not claims (§6.0 resolution).
 */
export function useValidOrganizations(user) {
    const userId = user?.userId ?? null;
    const { data, isLoading } = useQuery({
        queryKey: ['userOrgs', userId],
        queryFn: async () => {
            const repo = await repositoryFactory.getRepository(`user/${userId}/orgs`, USER_ORGS, DataSourceStrategy.Firestore, CacheStrategy.InMemory);
            const orgs = await repo.getAll();
            return orgs.map((o) => o.id);
        },
        enabled: !!userId,
        staleTime: 5 * 60 * 1000,
    });
    return { orgIds: data ?? [], isLoading: !!userId && isLoading };
}
//# sourceMappingURL=useValidOrganizations.js.map